export const VERSION_ACTION = {
  GET_BACKEND_VERSION: 'GET_BACKEND_VERSION',
  GET_BACKEND_VERSION_SUCCESS: 'GET_BACKEND_VERSION_SUCCESS',
  GET_BACKEND_VERSION_FAILED: 'GET_BACKEND_VERSION_FAILED',
};
// =========================================================================
export const getBackendVersion = () => ({
  type: VERSION_ACTION.GET_BACKEND_VERSION,
});
